import {SearchResponse} from '@algolia/client-search'
import algoliarecommend from '@algolia/recommend'

import settings from '../constants/settings'
import {ruleContext} from './algolia'
import {VariantList} from './rest'

const recommendClient = algoliarecommend(
  settings.algoliaApplicationId,
  settings.algoliaApiKey,
  )

export const recommendIndexName = `${settings.algoliaEnvPrefix}_products`

export async function frequentlyBoughtTogether(
  sku: string,
): Promise<SearchResponse<VariantList> | undefined> {
  const data = await recommendClient.getFrequentlyBoughtTogether<VariantList>([
    {
      indexName: recommendIndexName,
      objectID: sku,
      queryParameters: {
        ruleContexts: [ruleContext],
      },
    },
  ])
  return data.results?.length ? data.results[0] : undefined
}

export async function relatedProducts(
  sku: string,
): Promise<SearchResponse<VariantList> | undefined> {
  const data = await recommendClient.getRelatedProducts<VariantList>([
    {
      indexName: recommendIndexName,
      objectID: sku,
      queryParameters: {
        ruleContexts: [ruleContext],
      },
    },
  ])
  return data.results?.length ? data.results[0] : undefined
}


export async function recommendations(sku: string, userToken?: string): Promise<SearchResponse<VariantList>[] | undefined> {
  const data = await recommendClient.getRecommendations<VariantList>([
    {
      indexName: recommendIndexName,
      objectID: sku,
      model: 'bought-together',
      maxRecommendations: 6,
      queryParameters: {
        ruleContexts: [ruleContext],
        userToken,
        clickAnalytics: true,
      },
    },
    {
      indexName: recommendIndexName,
      objectID: sku,
      model: 'related-products',
      maxRecommendations: 6,
      queryParameters: {
        ruleContexts: [ruleContext],
        userToken,
        clickAnalytics: true,
      },
    }
  ])
  return data?.results?.length ? data.results : undefined
}
